export function classifyVenuesForRecipeShare(missingMap = {}) {
  const cannotShare = []
  const canAddAndShare = []
  const canShareDirectly = []
  const canShareDirectlyNoOms = []
  const unclassifiedVenues = []

  Object.entries(missingMap).forEach(([venue, info]) => {
    const notInCatalogue = info?.notInCatalogue || []
    const notInShoppingList = info?.notInShoppingList || []
    const inCatalogue = info?.inCatalogue || []
    const inShoppingList = info?.inShoppingList || []

    if (notInCatalogue.length > 0) {
      cannotShare.push({ venue, notInCatalogue })
    } else if (
      notInCatalogue.length === 0 &&
      notInShoppingList.length === 0 &&
      inCatalogue.length === 0 &&
      inShoppingList.length === 0
    ) {
      canShareDirectlyNoOms.push(venue)
    } else if (
      notInCatalogue.length === 0 &&
      notInShoppingList.length === 0 &&
      inShoppingList.length > 0 &&
      inCatalogue.length === 0
    ) {
      canShareDirectly.push(venue)
    } else if (
      notInCatalogue.length === 0 &&
      notInShoppingList.length > 0 &&
      inCatalogue.length > 0
    ) {
      canAddAndShare.push({ venue, notInShoppingList })
    } else {
      unclassifiedVenues.push(venue)
    }
  })

  const shareableVenueTitles = [
    ...canAddAndShare.map(item => item.venue),
    ...canShareDirectly,
    ...canShareDirectlyNoOms,
  ]

  return {
    cannotShare,
    canAddAndShare,
    canShareDirectly,
    canShareDirectlyNoOms,
    unclassifiedVenues,
    shareableVenueTitles,
  }
}

export function resolveShareableVenueIds(
  shareableVenueTitles,
  venueTitleToId = {},
) {
  return shareableVenueTitles
    .map(title => venueTitleToId[title])
    .filter(Boolean)
}
